import { LOCALES } from './generated/locale';
export * from './generated/locale';
export interface ILocale {
  language: string | undefined;
  region: string | undefined;
}

export type Locale = keyof typeof LOCALES;
